// Centralized lazy route importers so we can both render via React.lazy
// AND prefetch the same chunk on hover/focus.
export const routeImporters: Record<string, () => Promise<unknown>> = {
  "/portfolio": () => import("@/pages/Portfolio"),
  "/projects": () => import("@/pages/AllProjects"),
  "/projects/local-seo": () => import("@/pages/LocalSeoProject"),
  "/projects/ecommerce-seo": () => import("@/pages/EcommerceSeoProject"),
  "/projects/technical-seo": () => import("@/pages/TechnicalSeoProject"),
  "/projects/content-seo": () => import("@/pages/ContentSeoProject"),
  "/projects/international-seo": () => import("@/pages/InternationalSeoProject"),
  "/projects/seo-analytics": () => import("@/pages/SeoAnalyticsProject"),
  "/projects/meta-ads-zinzo": () => import("@/pages/MetaAdsZinzoProject"),
  "/projects/youtube-seo": () => import("@/pages/YoutubeSeoProject"),
  "/blog": () => import("@/pages/Blog"),
  "/contact": () => import("@/pages/Contact"),
  "/auth": () => import("@/pages/Auth"),
  "/admin": () => import("@/pages/AdminDashboard"),
  "/services/local-seo": () => import("@/pages/services/LocalSeoService"),
  "/services/youtube-seo": () => import("@/pages/services/YoutubeSeoService"),
  "/services/ecommerce-seo": () => import("@/pages/services/EcommerceSeoService"),
  "/services/meta-ads": () => import("@/pages/services/MetaAdsService"),
  "/services/digital-marketing": () => import("@/pages/services/DigitalMarketingService"),
};

const prefetched = new Set<string>();

export function prefetchRoute(path: string) {
  // Match exact route or strip hash/query
  const clean = path.split("#")[0].split("?")[0];
  if (prefetched.has(clean)) return;
  const importer = routeImporters[clean];
  if (!importer) return;
  prefetched.add(clean);
  // Fire and forget; ignore errors (will retry naturally on real nav)
  importer().catch(() => prefetched.delete(clean));
}

/** Convenience props spreader for <Link> / <a> elements. */
export const prefetchHandlers = (path: string) => ({
  onMouseEnter: () => prefetchRoute(path),
  onFocus: () => prefetchRoute(path),
  onTouchStart: () => prefetchRoute(path),
});
